export const BONUS_OPTIONS = [
  {text: 'CAB earned', id: 'cabEarnedLastPeriod'},
  {text: 'AAB earned', id: 'aabEarnedLastPeriod'},
];
